// src/pages/TermsConditions.js
import React from "react";

const sections = [
  {
    title: "1. Company Information",
    content: [
      `Revibe Health and Happiness
2206, 22nd Floor, Solus, Hiranandani Estate,
Patlipada, Near Hiranandani School,
Thane (West), Maharashtra – 400607.`,
    ],
  },
  {
    title: "2. Eligibility",
    content: [
      "You must be at least 18 years old to create an account and purchase subscriptions.",
      "If under 18, use our Services only with parental/guardian supervision.",
    ],
  },
  {
    title: "3. Services Provided",
    content: [
      "Online fitness classes including weight loss programs, diet guidance, exercise routines, Zumba, cardio, and muscle training sessions.",
      "Subscription-based access to pre-recorded and live-streamed classes via Android, iOS, and Smart TV applications.",
    ],
  },
  {
    title: "4. Account Registration",
    content: [
      "Create an account with accurate personal information.",
      "Maintain confidentiality of login details.",
      "Notify us immediately of any unauthorized access.",
    ],
  },
  {
    title: "5. Subscriptions & Payments",
    content: [
      "Subscription fees displayed before purchase.",
      "Payments processed securely via Razorpay, Stripe, PayPal, etc.",
      "Subscriptions are non-transferable and linked to your registered account.",
    ],
  },
  {
    title: "6. Refund & Cancellation Policy",
    content: [
      "Subscription fees are generally non-refundable.",
      "Cancel anytime; access remains until the end of the paid period.",
      "For technical issues or duplicate payments, contact support@revibe.app.",
    ],
  },
  {
    title: "7. User Responsibilities",
    content: [
      "Consult a physician before starting any fitness program.",
      "Use the App for personal, non-commercial purposes only.",
      "Do not misuse, copy, or redistribute content without permission.",
      "Avoid unlawful or harmful activities while using the App.",
    ],
  },
  {
    title: "8. Health Disclaimer",
    content: [
      "Revibe health and happiness application provides general fitness guidance only.",
      "Not a medical organization; consult professionals for health concerns.",
      "Not liable for injuries, health issues, or damages from using Services.",
    ],
  },
  {
    title: "9. Intellectual Property",
    content: [
      "All content including logos, videos, images, class materials, and software is property of Revibe health and happiness application.",
      "No copying, reproduction, or distribution without prior written consent.",
    ],
  },
  {
    title: "10. Limitation of Liability",
    content: [
      "Not responsible for interruptions, technical errors, or service unavailability.",
      "Liability limited to the subscription amount paid, to the maximum extent permitted by law.",
    ],
  },
  {
    title: "11. Termination of Account",
    content: [
      "We may suspend or terminate accounts for violating Terms, misuse, or payment issues (fraud, chargebacks, etc.).",
    ],
  },
  {
    title: "12. Governing Law & Jurisdiction",
    content: [
      "Governed by the laws of India.",
      "Any disputes are subject to the courts of Maharashtra, India.",
    ],
  },
  {
    title: "13. Changes to Terms",
    content: [
      "Terms may be updated from time to time.",
      "Major changes communicated via email or App notifications.",
      "Continued use signifies acceptance of updated Terms.",
    ],
  },
  {
    title: "14. Contact Us",
    content: [
      `Revibe Health and Happiness
2206, 22nd Floor, Solus, Hiranandani Estate,
Patlipada, Near Hiranandani School,
Thane (West), Maharashtra – 400607
Email: hello@getrevibe.app
Phone: +91 99677 22756`,
    ],
  },
];

const TermsConditions = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 sm:px-10 lg:px-12 xl:px-16 py-12">
      <h1 className="text-4xl font-bold mb-8 text-gray-900 text-center">
        Terms & Conditions
      </h1>

      <div className="space-y-8">
        {sections.map((section, index) => (
          <div key={index}>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              {section.title}
            </h2>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              {section.content.map((item, i) => (
                <li key={i} className="whitespace-pre-line">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* <p className="text-center text-gray-500 mt-12 text-sm">
        © {new Date().getFullYear()} Revibe Health and Happiness. All Rights
        Reserved.
      </p> */}
    </div>
  );
};

export default TermsConditions;
